<span
  *ngIf="!isLoggedIn"
  class="icon icon-loading"
></span>
